<template>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <shop-header title="必比登"/>
        <a href="https://paopaotui.com.tw/activity.html" target="_blank">
            <div class="tips">
                <span>必比登使用注意事項</span>
                <img src="@/assets/img/notices.png">
            </div>
        </a>
        <div class="content">
            <shop v-for="shop in shops" :shop="shop" :key="shop.id"/>
        </div>
    </div>
</template>

<script>
    import Shop from './components/shop/ShopItem';
    import Header from './components/Header';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'Shops',
        data() {
            return {
                loading: false
            }
        },
        components: {
            'shop': Shop,
            'shop-header': Header,
        },
        computed: {
            canNotLoadMore() {
                return !(this.shopMeta.total && this.shopMeta.current_page < this.shopMeta.last_page && !this.loading);
            },
            ...mapGetters(['shops', 'shopMeta'])
        },
        methods: {
            loadMore() {
                this.loading = true;
                this.loadMoreShops().then(() => {
                    this.loading = false;
                });
            },
            ...mapActions(['loadMoreShops'])
        },
    };
</script>

<style scoped>
    .tips {
        height: 20px;
        color: rgba(51,153,51,1);
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        display: flex;
        align-items: center;
        margin: 0 30px;
    }

    .tips > img {
        width: 20px;
        height: 20px;
    }

    .header {
        padding: 15px;
        position: relative;
    }

    .title {
        height: 22px;
        color: rgba(0,0,0,1);
        font-size: 14px;
        font-weight: 600;
        letter-spacing: -0.34px;
        line-height: 22px;
        text-align: center;
    }

    .back {
        transform: rotateY(180deg);
        width: 20px;
        height: 20px;
        position: absolute;
        left: 10px;
    }

    .content {
        margin-bottom: 15px;
    }

    a {
        text-decoration: none;
    }
</style>
